import type { FaireProductEntity } from "../../entity_types/product";

export const p_vhtfdz73m3: FaireProductEntity = {
  token: "p_vhtfdz73m3",
  type: "product",
  name: "CLEARANCE Ritual Bell",
  brandToken: "b_fpfqb8hgs8",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/7751f65157ebc83a610f6799dd6c5ca7afa01b8ce9230da4637e741123978579.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/82f46f3585b20c6f1ff9e493e1f9cd8db1196cac89502f99e02892962e77fd77.jpeg",
  ],
  priceDollars: 21,
  description:
    "\nCrafted to evoke calmness and inner peace, its soothing chimes resonate through the air, creating a tranquil ambiance. \n\nWhether used for meditation, mindfulness practices, or simply to bring a sense of tranquility to your space, this bell invites moments of reflection and relaxation. \n\nEmbrace the gentle harmony it brings, and let its ethereal tones guide you to a state of tranquility.\n\nAvailable in one size: 7.5” H x 3.75” Base Diameter\n\nWeight: 1lb 2oz\n\nMaterial: Brass\n\nEthically made in India.\n\n\n",
  tags: [],
  msrpDollars: 42,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:44.338Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
